import { ExamCenterProctorType } from '@exam-center/graphql';
import { phoneNumberFormatter } from '@exam-center/utils';

import { type ExamCenterProctorDetailsFormInput, type ExamCenterProctor } from '../providers';

export function getExamCenterProctorDetailsDefaultValues(input: {
  proctor: ExamCenterProctor;
}): ExamCenterProctorDetailsFormInput {
  const { proctor } = input;

  const isThirdLevelProctor = proctor.type === ExamCenterProctorType.Proctor_3;
  const email = isThirdLevelProctor ? (proctor.email ?? '') : undefined;

  const phoneNumber = phoneNumberFormatter(proctor.phoneNumber ?? '');

  return {
    personal: {
      email,
      phoneNumber,
      address: proctor.address ?? '',
    },
    employeeInfo: {
      code: proctor.metadata?.employeeId ?? '',
      position: proctor.metadata?.position ?? '',
      department: proctor.metadata?.department ?? '',
    },
  };
}
